<template>
  <promotion-sheet-component />
  <shop-sheet-component />
</template>

<script>
import PromotionSheetComponent from "@/components/sheets/PromotionSheetComponent.vue";
import ShopSheetComponent from "@/components/sheets/ShopSheetComponent.vue";

export default {
  name: "GlobalComponents",
  components: {
    PromotionSheetComponent,
    ShopSheetComponent,
  },
};
</script>
